export default {
      id: "old_miner-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "icons.svg#old_miner",
      toString: function () {
        return this.url;
      }
    }